export function clone<T>(object: T): T {
    var newobj = <T>{};
    for (var key in object)
        if (object.hasOwnProperty(key))
            newobj[key] = object[key];
    return newobj;
}

export function copyProperties<T>(src: Object, dst: T): T {
    for (var prop in dst)
        dst[prop] = src[<any>prop];

    return dst;
}

export function isNullOrUndefined(value) {
    return value === null || typeof value === 'undefined';
};

export function isNullOrWhitespace(value) {
    return isNullOrUndefined(value) || (typeof value === 'string' && value.trim().length === 0);
}

export function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

export function sort(data: any, orderClause: string) {
    var reverse: number = 1;
    if (orderClause && orderClause[0] === "-") {
        reverse = -1;
        orderClause = orderClause.substr(1);
    }

    return data.sort((a: any, b: any) => {
        if (a[orderClause] < b[orderClause]) return (-1 * reverse);
        if (a[orderClause] > b[orderClause]) return (1 * reverse);
        return 0;
    });;
}

export function allThere(array: any[], skip: number, take: number): boolean {
    if (!array)
        return false;
    var range: number[] = Array.apply(null, Array(take)).map((_, i) => { return skip + i });
    return range.some(a => array[a]);
}

export function waitfor(test, expectedValue, msec, count, source, callback) {
    // Check if condition met. If not, re-check later (msec).
    while (test() !== expectedValue) {
        count++;
        setTimeout(function () {
            waitfor(test, expectedValue, msec, count, source, callback);
        }, msec);
        return;
    }
    // Condition finally met. callback() can be executed.
    callback();
}

export function storeObj(key: string, obj: any) {
    localStorage.setItem(key, JSON.stringify(obj));
}

export function getObj(key: string) {
    return JSON.parse(localStorage.getItem(key));
}

export function removeObj(key: string) {
    localStorage.removeItem(key);
}

export function moveArrayElement(arr: any[], from: number, to: number) {
    if (from < 0 || from >= arr.length || to < 0 || to >= arr.length)
        return

    arr.splice(to, 0, arr.splice(from, 1)[0]);
}

export function fiscalYearForDate(forDate?: Date): number {
    if (isNullOrUndefined(forDate))
        forDate = new Date();

    return forDate.getFullYear() + ((forDate.getMonth() > 9) ? 1 : 0);
}

export function dollarFmt(val: number) {
    return (((Math.abs(Number(val))) / Number(val) < 0) ? '-' : '') + '$' + Math.abs(Number(val)).toFixed(0).replace(/./g, function (c, i, a) {
        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
    });
}

export function shortNumberFmt(val: number, prefix: string = '$') {
    if (val !== 0) {
        let suffi: string[] = ['', 'k', 'm', 'b'];
        let x: number = Math.trunc(Math.log10(val) / 3);
        let div = Math.pow(10, x * 3);
        let disp = ((val / div) < 10) ? Math.trunc(val * 10 / div) / 10 : Math.trunc(val / div);
        return prefix + disp + suffi[x];
    }
    else return '';
}

export function percentFmt(val: number) {
    return Math.round(val * 1000) / 10 + '%';
}

export function formatNMAError(err: any) {
    if (err.request?.responseText) {
        let rsp = JSON.parse(err.request?.responseText);
        if (rsp?.ExceptionMessage)
            return `${err.message} : ${rsp.ExceptionMessage}`;
    }
    return err.message;
}

export function convertDateStringIgnoreZone(dateString: string): Date {
    const year = parseInt(dateString.substring(0, 4));
    const monthIndex = parseInt(dateString.substring(5, 7)) - 1;
    const day = parseInt(dateString.substring(8, 10));
    return new Date(year, monthIndex, day, 12, 0, 0);
}